/**
 * Splits a comma-separated string into an array
 */
export function stringToList(value?: string | string[]): string[] {
  if (!value) return [];

  if (Array.isArray(value)) return value;

  return value
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
}
